import React from 'react';
import ConfirmActionModal from '../../components/ConfirmActionModal';
import type { ActionModalProps } from '../../constants';
import useTrackEvent from '~/hooks/useTrackEvent';

export type Props = {
  dataTestId?: string;
} & ActionModalProps;

const UnsubscribeEmail: React.FCC<Props> = ({
  onCancel,
  onComplete,
  selectedContactAmount,
  ...rest
}) => {
  const trackEvent = useTrackEvent();
  return (
    <ConfirmActionModal
      selectedContactAmount={selectedContactAmount}
      actionType="UnsubscribeEmail"
      actionInput={{
        UnsubscribeEmail: {},
      }}
      onComplete={() => {
        /** ----- TRACKING: contacts_unsubscribed ----- */
        trackEvent({
          eventName: 'contacts_unsubscribed',
          parameters: {
            contacts_amount: selectedContactAmount,
          },
        });
        onComplete();
      }}
      onCancel={onCancel}
      {...rest}
    />
  );
};

export default UnsubscribeEmail;
